import React, { FC } from 'react';
import { useRouter } from 'next/router';
import { Icons } from '@components/Icon';
import useTranslations from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import { handleDownloadClick,handleDownloadClickAsZip } from '@utils/material.utils';
import { Material, MaterialIcon, MaterialLabel, Materials, Preview, Title, Wrapper } from './TrainingMaterial.elements';

export interface TrainingMaterialProps {
    attachments: {
        name: string;
        filename: string;
        _key: string;
        mime_type: string;
    }[];
}

const TrainingMaterialTemplate: FC<TrainingMaterialProps> = ({ attachments }) => {
    const { t } = useTranslations();

    const router = useRouter();

    return (
        <Wrapper>
            {attachments?.length > 0 && (
                <>
                    <Title>{t('training.materials.title')}:</Title>
                    <Materials>
                        {attachments?.map((attachment, key) => (
                            <Material
                                onClick={() => handleDownloadClick(attachment._key, attachment.name)}
                                key={key}
                            >
                                <MaterialIcon name={Icons.File} />
                                <MaterialLabel>{attachment?.name}</MaterialLabel>
                            </Material>
                        ))}
                    </Materials>
                    <Preview>
                        <ButtonTemplate
                            onClick={() => handleDownloadClickAsZip(attachments, router.query.slug as string)}
                            marginTop={25}
                            text={t('material.download.all')}
                        />
                    </Preview>
                </>
            )}
        </Wrapper>
    );
};

export default TrainingMaterialTemplate;
